import React from "react";
import moment from "moment";
import {Box, Button, Container, Drawer, FormControlLabel, List, ListItem, Switch, Typography} from "@mui/material";
import Calendar from "./partial/Calendar";
import SlideDatepicker from "./partial/SlideDatepicker";
import PTORequest from "./partial/PTORequest";

export default function Shifts(props) {
  const [state, setState] = React.useState({
    date: sessionStorage.getItem("schedules_date") || moment().format("yyyy-MM"),
    gekkan: false,
    pg: 0,
    stopRender: true
  });
  const [open, setOpen] = React.useState({
    ptoRequest: false
  })

  return (
    <Container
      maxWidth = "sm"
      sx = {{p: 0, flexGrow: 1}}
    >
      <Box
        className = "bgcolor-white"
        position = "sticky"
        sx = {{width: "100%", top: 55, pt: 2, textAlign: "center", zIndex: 1}}
      >
        <SlideDatepicker
          setState = {setState}
          state = {state}
          ymdFg = {false}
        />
        <List>
          <ListItem>
            <Button
              className = "btn-submit"
              id = "request_leave_btn"
              onClick = {() => setOpen({...open, ptoRequest: !(open.ptoRequest)})}
              sx = {{mr: "auto", width: "48%"}}
            >
              <Typography
                className = "btn-txt-lg"
              >
                休暇申請
              </Typography>
            </Button>
            <FormControlLabel
              control = {<Switch onChange = {(e) => setState({...state, gekkan: e.target.checked})} />}
              label = "月間"
              sx = {{ml: "auto"}}
            />
          </ListItem>
        </List>
      </Box>
      {new Date(state.date + "-01").toLocaleDateString() !== "Invalid Date" &&
      <Calendar
        setState = {setState}
        setToastState = {props.setToastState}
        state = {state}
        toastState = {props.toastState}
      />}
      <Drawer
        anchor = "bottom"
        open = {open.ptoRequest}
        PaperProps = {{sx: {height: "100%"}}}
      >
        <PTORequest
          date = {state.date}
          setState = {setState}
          setToastState = {props.setToastState}
          state = {state}
          toastState = {props.toastState}
        />
      </Drawer>
    </Container>
  );
};
